import { render, staticRenderFns } from "./tablestat.vue?vue&type=template&id=37351cf6&"
import script from "./tablestat.vue?vue&type=script&lang=js&"
export * from "./tablestat.vue?vue&type=script&lang=js&"
import style0 from "./tablestat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports